import React, { useEffect } from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import { useHistory } from "react-router-dom";

import {
  apollo_billing_resources_path,
} from "../../atom/Apollo_links";

import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from "@material-ui/core/TextField/TextField";

import { useForm } from "react-hook-form";

import { AccountGroup } from "../../organism/ACCOUNT/AccountModel";

import { ApolloMessage } from "../../atom/Apollo_Mesasge";
import { ApolloAxios } from "../../atom/Apollo_ApiRequest3";
import ApolloMasterBillingModal from "../../organism/MASTER/Apollo_MasterBillingModal";
import {
  Option,
  valueToOptionNull,
} from "../../atom/Apollo_styles";
// 認証期間切れの処理
import { ApolloExpired } from "../../atom/Apollo_Expired";

// エラーメッセージ
const ERROR_MESSGAE = [
  "請求リソースの取得に失敗しました。",
];

export type PropsSelectBillingResource = {
  defaultValue: number       // 初期選択値
  value: number              // 選択値
  setValue: any              // 選択値セット関数
  isDisabled: boolean        // 不活化
  required: boolean          // 必須
  accountgroup: AccountGroup // アカウントグループ情報
  setLabel: any              // 選択値セット関数
}

interface SelectBillingResourceProps {
  propsSelect: PropsSelectBillingResource
};

// 状態選択セレクトボックス表示
export default function ApolloSelectBillingResource(props: SelectBillingResourceProps) {

  const { data, setmsg } = React.useContext(ApolloMessage);
  const { errors, setError, clearErrors } = useForm();

  const [read, setRead] = React.useState(0);
  const [billData, setBillData] = React.useState([{}]);
  const [billOption, setBillOption] = React.useState<Option[]>([]);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();

  const {
    value,
    setValue,
    isDisabled,
    required,
    accountgroup,
    setLabel,
  } = props.propsSelect;

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  // 請求リソース取得
  useEffect(() => {
    const url = apollo_billing_resources_path;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        accountgroup.billingId = response.data.result[0].billingId;
        const rows = response.data.result.map((data: any) => {
          return { "value": data.billingId, "label": data.billingId + " : " + data.billingName + " : " + (data.creditLimitAmount ? data.creditLimitAmount.toLocaleString() : "0") };
        });
        setData(rows);
        setBillOption(rows);
        if (read > 0) {
          setValue(accountgroup.billingId);
        }
      } else {
        console.log(response.data.message);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: ERROR_MESSGAE[0],
          },
        });
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, ERROR_MESSGAE[0], data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [read]);

  const setData = (rows: [Option]) => {
    setBillData(rows);
  }

  // 請求リソース選択ハンドラ
  const handleChangeBill = (event: any, element: any, reason: any) => {
    if (reason === "select-option" && element !== null) {
      if (element.value !== null) {
        setValue(element.value);
        setLabel(element.label);
        clearErrors("billingId")
      } else {
        setError("billingId", {
          type: "manual",
          message: "必須入力項目です。"
        });
      }
    } else if (reason === "clear") {
      setValue(0);
      setLabel("");
      setError("billingId", {
        type: "manual",
        message: "必須入力項目です。"
      });
    }
  };

  return (
    <Grid item xs={12} container>
      <Grid item xs={12} md={10}>
        <InputLabel id="bellingId">
          <Typography variant="caption">
            請求リソース *
          </Typography>
        </InputLabel>
        <FormControl error={errors.bellingId ? true : false} fullWidth>
          {billOption.length > 0 && (
            <Autocomplete
              id="bellingId"
              value={valueToOptionNull(value, billOption)}
              key={value ? "Loaded" : "Loading"}
              options={billOption}
              onChange={(event, element, reason) => handleChangeBill(event, element, reason)}
              disabled={isDisabled}
              size="small"
              closeIcon=""
              getOptionSelected={(option, value) => option.value === value.value}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} variant="outlined" />}
            />
          )}
          <FormHelperText>{errors.bellingId && errors.bellingId.message}</FormHelperText>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <Grid item container alignItems="flex-start" justify="flex-start">
          <Grid>
            {/* 請求リソース追加ボタン */}
            <ApolloMasterBillingModal kind={"追加"} isDisabled={isDisabled} billingId={0} setRead={setRead} read={read} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
